import styled from 'styled-components';
import MenuButton from '../../../Shared/MenuButton';
import MenuDrawerItem from '../../../Shared/MenuDrawerItem';

const StyledMenuButton = styled(MenuButton)`
  color: ${props => props.theme.carvana.blue.dark};
  height: 60px;
  justify-content: flex-start;
  width: 100%;
`;

const StyledMenuDrawerItem = styled(MenuDrawerItem)`
  background-color: ${props => props.theme.carvana.gray.background};
  padding: 0 32px;
`;

export {
  StyledMenuButton,
  StyledMenuDrawerItem
};
